module.exports = __webpack_public_path__ + "static/media/user.87d7e8ac.png";